import {OnlinePaymentStatusEnum} from '@/services/api-clients';

export function onlinePaymentStatusColorFilter(status: OnlinePaymentStatusEnum): [string, string] {
  switch (status) {
    case OnlinePaymentStatusEnum.Waiting: return ['primary', 'primary--text'];
    case OnlinePaymentStatusEnum.Approved: return ['success', 'success-text'];
  }
}
